const CutScreenClass = resolve => require(['@/components/admin/schoolScoreManagement/CutScreenClass.vue'], resolve)

export default {
  path: '/schoolScoreManagement/cutScreenClass',
  component: CutScreenClass,
  meta: {
    title: '学校班级切屏情况',
    path: '/homePage/scoreManagement',
    breadList: [
      {
        title: '首页',
        path: '/homePage'
      },
      {
        title: '成绩管理',
        path: '/homePage/scoreManagement'
      },
      {
        title: '学校详情',
        path: '/homePage/allSchoolExam'
      },
      {
        title: '学校班级切屏情况',
        path: '/schoolScoreManagement/cutScreenClass'
      }
    ]
  },
}



// WEBPACK FOOTER //
// ./src/router/admin/cutScreenClass.js